import CircledNumber from '../../../sharedComponents/CircledNumber.styled';
import StepsContainer from '../../../sharedComponents/StepsContainer.styled';
import StepsDescription from '../../../sharedComponents/StepsDescription.styled';

type PropsT = {
    stepsHeading?: string;
    steps: string[];
    stepsDescription?: string[];
    stepsFooter?: string;
};

const ConfirmSteps = ({
    stepsHeading,
    steps,
    stepsDescription,
    stepsFooter,
}: PropsT) => (
    <>
        <div className='h3'>{stepsHeading}</div>
        <ol className="mb-1 d-flex flex-wrap flex-column pl-0">
            {steps.map((step, index) => (
                <li key={step} className='d-flex'>
                    <CircledNumber>{ index + 1 }</CircledNumber>
                    <StepsContainer>
                        <div>
                            <div className='my-1'><StepsDescription>{ step }</StepsDescription></div>
                            <div className='my-1'>{ stepsDescription?.[index] }</div>
                        </div>
                    </StepsContainer>
                </li>
            ))}
        </ol>
        <p className="mb-4">{stepsFooter}</p>
    </>
);

export default ConfirmSteps;
